export default __webpack_public_path__ + "prothomalo-colored.png";